import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
@Component({
  selector: 'app-custom-toast',
  templateUrl: './custom-toast.component.html',
  styleUrls: ['./custom-toast.component.scss'],
})
export class CustomToastComponent {
  @Input() title!: string;
  @Input() message!: string;
  @Input() avatar!: string;
  @Input() targetUrl!: string;

  constructor(private modalCtrl: ModalController, private router: Router) {}

  closeToast() {
    this.modalCtrl.dismiss();
  }

  viewMore() {
    this.modalCtrl.dismiss();
    if (this.targetUrl) {
      this.router.navigate([this.targetUrl], { queryParamsHandling: 'preserve' });
    }
  }
}
